var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScanArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1299 1303",
    fill: "black",
    stroke: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182 10H130C63.7258 10 10 63.7258 10 130V182M182 1292.16H130C63.7258 1292.16 10 1238.43 10 1172.16V1120.16M1117 10H1169C1235.27 10 1289 63.7258 1289 130V182M1117 1292H1169C1235.27 1292 1289 1238.27 1289 1172V1120",
    strokeWidth: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanArea);
export default __webpack_public_path__ + "static/media/scan-area.7fbff69e879160833ca84465e6c4792d.svg";
export { ForwardRef as ReactComponent };